import useCollection from "./useCollection"
import { snakecase } from "web/services/inflector"

/*
TODO: The includeSubjectFieldsForTopic flag is now only used by Summary Tiles (TileFieldSelector) - find a way to deprecate it
*/
export default function useFields({
  subjectType,
  topicId = "none",
  includeSubjectFieldsForTopic = false,
  includeMultipleSubjectsFields,
}) {
  const url = subjectType
    ? `/fields/${snakecase(subjectType)}/${topicId || "none"}`
    : null

  return useCollection({
    key: url ? [url, includeSubjectFieldsForTopic] : null,
    updatePath: "/fields",
    url,
    params: {
      include_subject_fields: includeSubjectFieldsForTopic || undefined,
      include_multiple_subjects_fields: includeMultipleSubjectsFields,
    },
  })
}
